import { GetCouponType, handleGetCoupon, handleQryCoupon, QryCouponType } from '../../business';
import { ActType } from '../type';
import { CouponActivity } from './coupon-activity';
import { ExecActState } from '@tencent/wphk-act-base-cgi/dist/activity/exec-useract/types';
/**
 * 派发活动
 */
export class DistributionActivity extends CouponActivity {
    constructor(distributionActivityOpts) {
        super(distributionActivityOpts.couponActRelation);
        /** 活动类型 */
        this.type = ActType.distribution;
        this.distributeActidList = distributionActivityOpts.distributeActidList;
        this.isNeedUserCouponid = distributionActivityOpts.isNeedUserCouponid;
    }
    /** 初始化活动信息 */
    async initAct() {
        /** 拉取券列表 */
        await this.qryCoupon();
    }
    /** 参与活动 */
    async execAct() {
        if (super.beforeExecAct()) {
            // getCoupon
        }
    }
    /** 查询并设置活动状态 */
    async setActState() { }
    /** 查询并设置用户参与活动状态 */
    async setUserActState() { }
    /** 查券 */
    async qryCoupon() {
        const list = await handleQryCoupon[QryCouponType.ExchActPrizeInfoByActId](this.type, this.couponActRelation, this.distributeActidList);
        this.couponList = list || [];
        // 查用户自己的券,获取用户领到的券
        if (this.isNeedUserCouponid) {
            const couponIdList = this.couponList.map((coupon) => coupon.prizeId);
            await this.getUserCouponList(couponIdList);
        }
    }
    /** 领券 */
    async getCoupon(params) {
        if (!params || !params.actListid || !params.prizeId) {
            throw new Error('参数错误');
        }
        const { actListid, prizeId } = params;
        const { execState } = await handleGetCoupon[GetCouponType.ExecAct](actListid, prizeId);
        return {
            isSuccess: execState === ExecActState.success,
            execState,
        };
    }
    /** 获取用户领到的券 */
    async getUserCouponList(couponIdList) {
        const list = await handleQryCoupon[QryCouponType.QryUserCouponList](couponIdList);
        this.userCouponList = list;
    }
}
